import { LogoutOptions } from '@auth0/auth0-react';
import { LocalStorageKeys, SENTRY_OPERATIONS } from '~/shared/constants';
import { reportError } from '~/shared/utils/sentry';
import { REST_BASE_URL } from '../config';

/**
 * Handles user logout by clearing all authentication and session-related
 * data from localStorage, clearing httpOnly cookies, and initiating Auth0 logout.
 *
 * This ensures a clean logout state and prevents stale data from affecting
 * future sessions.
 */
export const handleLogout = async (
  logout: (options?: LogoutOptions) => Promise<void>,
) => {
  // Clear programmatic token cookie if present
  // httpOnly cookies cannot be cleared via JavaScript, so we call the backend
  // endpoint to clear the cookie
  try {
    await fetch(`${REST_BASE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  } catch (error) {
    // Log but don't block logout if cookie clearing fails
    reportError(error, {
      operation: SENTRY_OPERATIONS.LOGOUT_CLEAR_COOKIE,
    });
  }

  // Clear invitation data from localStorage
  localStorage.removeItem(LocalStorageKeys.InvitationToken);
  localStorage.removeItem(LocalStorageKeys.InvitationDecision);

  // Initiate Auth0 logout and redirect to origin
  logout({ logoutParams: { returnTo: window.location.origin } });
};
